import cn from 'classnames';

const BuscadorButton = ({ label, active, onClick, ariaLabel, compact = false }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        'buscador-button relative bg-white text-cyan-dark rounded-full duration-40',
        compact ? 'py-8 px-10 sm:py-10 sm:px-18' : 'py-10 px-18',
        { '!bg-cyan-dark !text-white': active }
      )}
    >
      <p className={cn('p2 opacity-80', compact ? '!text-12 sm:!text-16' : '!text-14 sm:!text-16')}>
        {label}
      </p>
    </button>
  );
};
export default BuscadorButton;
